import { useEffect, useState } from 'react'
import { useNavigate } from "react-router-dom";
import PageMenu from 'components/blocks/PageMenu/PageMenu'
import IconArrowGray from "../../../../img/icons/svg/botones/flecha-big-gris.svg";
import { useParams } from 'react-router-dom';
import Loader from 'components/blocks/Loader/Loader';
import useDecode from 'hooks/useDecode';
import FormularioPECATA from './FormularioPECATA';
import useGetFormularioPECATAByID from 'services/record/FormularioPECATA/useGetFormularioPECATAByID';
interface Params {
    idprestacion: string;
    idform: string;
}


const HistorialFormularioPECATA = () => {
    const decoded = useDecode("token");
    const [data, setData] = useState(null);
    const navigate = useNavigate()
    const { dataGetFormularioPECATAByID, errorGetFormularioPECATAByID, getFormularioPECATAByID, loadingGetFormularioPECATAByID, successGetFormularioPECATAByID } = useGetFormularioPECATAByID();
    const { idprestacion, idform } = useParams<Record<string, string>>();


    useEffect(() => {
        const actualUrl = window.location.href;
        if (!actualUrl.includes('/mis-gestiones/formularios')) {
            const userId = decoded.extension_id;
            const prestacionId = idprestacion.split('_')[1];
            const formId = idform;

            getFormularioPECATAByID(userId, prestacionId, formId, setData);
        }
    }, []);

    return (
        <div>
            <PageMenu title={'Prestación económica por cese de actividad en autónomos'}>

                <div className="btns-header-container">
                    <button aria-label="Volver atrás" onClick={() => navigate(-1)}>
                        <img src={IconArrowGray} alt="" />
                    </button>
                </div>
            </PageMenu>


            {
                loadingGetFormularioPECATAByID ?
                    <Loader activeLoader={true} label="Cargando Formulario"></Loader>
                    :
                    <FormularioPECATA dataUser={data} info={false} />
            }




        </div>
    )
}

export default HistorialFormularioPECATA